import now from "./now";

const Now = {
  now
};
export default Now;
